import { buildErrorMessage } from "../../../apis/calls";
import { HIDE_NOTIFICATION, SHOW_NOTIFICATION } from "./actionTypes";

export const showNotification = (params) => async (dispatch) => {
  try {
    dispatch({
      type: SHOW_NOTIFICATION,
      payload: { ...params },
    });
  } catch (error) {
    console.error(buildErrorMessage(error));
  }
};

export const hideNotification = () => async (dispatch) => {
  try {
    dispatch({
      type: HIDE_NOTIFICATION,
      payload: { open: false, type: "", title: "", subtitle: "" },
    });
  } catch (error) {
    console.error(buildErrorMessage(error));
  }
};
